import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

function useItemNutrition(itemId: string) {
    const { data: nutrition, ...rest } = useQuery({
        ...queries.items.nutrition(itemId),
        retry: 2,
    });
    const isNutritionExists = useMemo(() => {
        if (nutrition) {
            const keys = Object.keys(nutrition);
            for (let i = 0; i < keys.length; i += 1) {
                // @ts-ignore
                if (nutrition[keys[i]]) {
                    return true;
                }
            }
        }
        return false;
    }, [nutrition]);
    return { nutrition, isNutritionExists, ...rest };
}

export default useItemNutrition;
